import React, { useEffect, useRef, useState } from 'react';
import type { CustomCellEditorProps } from 'ag-grid-react';
import type { UserRow } from '../../types/User';

// AgGrid v35 functional cell editor: receives value/onValueChange/stopEditing.
// Renders a real <input type="password"> so the temp password is never shown
// in plaintext in the DOM during entry. Empty value = "no change" on edit.
export function PasswordCellEditor({
  value,
  onValueChange,
  stopEditing,
}: CustomCellEditorProps<UserRow, string>) {
  const [val, setVal] = useState<string>(value ?? '');
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <input
      ref={ref}
      type="password"
      className="lop-password-editor"
      autoComplete="new-password"
      value={val}
      onChange={(e) => {
        setVal(e.target.value);
        onValueChange(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Escape') stopEditing();
      }}
    />
  );
}
